import { createStyles } from '@mantine/core';
import { SecurityStatusColors } from './SecurityStatusColors.js';
var useStyles = createStyles(function () {
  return {
    color: {
      color: "var(--color)"
    },
    background: {
      backgroundColor: "var(--color)"
    },
    "0": {
      "--color": SecurityStatusColors["0"]
    },
    "1": {
      "--color": SecurityStatusColors["1"]
    },
    "2": {
      "--color": SecurityStatusColors["2"]
    },
    "3": {
      "--color": SecurityStatusColors["3"]
    },
    "4": {
      "--color": SecurityStatusColors["4"]
    },
    "5": {
      "--color": SecurityStatusColors["5"]
    },
    "6": {
      "--color": SecurityStatusColors["6"]
    },
    "7": {
      "--color": SecurityStatusColors["7"]
    },
    "8": {
      "--color": SecurityStatusColors["8"]
    },
    "9": {
      "--color": SecurityStatusColors["9"]
    },
    "10": {
      "--color": SecurityStatusColors["10"]
    }
  };
});
export { useStyles as default };